module.exports = __webpack_public_path__ + "static/media/banner-e3.1ab14770.jpg";